import { findParentNodeClosestToPos } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { TIPTAP_LAYOUT_TYPE } from './../../ricos-content';

export const layoutSelectionDecorationPlugin = () => {
  return new Plugin({
    key: new PluginKey('layout-selection-decoration'),
    props: {
      decorations(state) {
        const { $from } = state.selection;
        const layoutNode = findParentNodeClosestToPos(
          $from,
          node => node.type?.name === TIPTAP_LAYOUT_TYPE
        )?.node;
        const decorations: Decoration[] = [];

        // We don't really care what decoration to set here. This is needed only because PM doesn't
        // trigger `update` for node views on selection change as it thinks nothing changed. Adding
        // decorations for helps to force it.
        state.doc.forEach((node, pos) => {
          if (node === layoutNode) {
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                'data-layout-selection': '',
              })
            );
          }
        });
        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
};
